import {z} from "zod/v4-mini"

/** Blender 5.2 renumbered the enum: its RANDOM_WALK_LEGACY holds the value 4.2 stores for RANDOM_WALK, and its RANDOM_WALK is a new algorithm. */
export type SubsurfaceFalloff = "BURLEY" | "RANDOM_WALK" | "RANDOM_WALK_SKIN"
export const subsurfaceFalloffSchema = z.enum(["BURLEY", "RANDOM_WALK", "RANDOM_WALK_SKIN"])
